const audio = (file_path, title = '', category = '', sub_category = '') => {
    return {
        type: 'OPEN',
        payload: { file_path, title, category, sub_category }
    }
}

export { audio }